import React from 'react';
import { useTranslation } from 'react-i18next';

import { getBenefitsList } from '../../constants';

import css from './promoteVipPopupBenefitsList.module.sass';

export const PromoteVipPopupBenefitsList: React.FC = () => {
  const { t } = useTranslation(['common', 'app']);

  return (
    <ul className={css.list}>
      {getBenefitsList(t).map((benefit) => (
        <li className={css.item} key={benefit.caption}>
          <benefit.icon className={css.icon} />
          <span className={css.caption}>{benefit.caption}</span>
        </li>
      ))}
    </ul>
  );
};
